import { createContext, useContext } from "react";

export const FormStepIdContext = createContext<string | undefined>(undefined);

export function useFormStepId(): string | undefined {
  return useContext(FormStepIdContext);
}
